import { NAV_LINKS } from '../constants/navigation';

export default function Footer() {
  const goto = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="nav-logo">
          <span
            className="brand-logo-frame brand-logo-symbol-frame brand-logo-frame-footer"
            aria-hidden="true"
          >
            <img className="brand-logo brand-logo-footer" src="/logo.jpg" alt="" />
          </span>
          <div className="footer-brand-copy">
            <div className="brand-wordmark brand-wordmark-footer" aria-label="Kalakar Tech Crew">
              <span className="brand-wordmark-main">Kalakar</span>
              <span className="brand-wordmark-sub">TECH CREW</span>
            </div>
            <div className="subtitle" style={{ marginTop: 4 }}>
              Digital products, automation, and growth systems
            </div>
          </div>
        </div>

        <div className="footer-nav">
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => goto(l.id)}>
              {l.label}
            </button>
          ))}
        </div>

        <div className="footer-social">
          <a className="btn btn-outline btn-small" href="https://www.instagram.com/kalakartechcrew/" target="_blank" rel="noreferrer">
            Instagram
          </a>
          <a className="btn btn-outline btn-small" href="https://www.linkedin.com/company/kalakar-techcrew/" target="_blank" rel="noreferrer">
            LinkedIn
          </a>
        </div>

        <div className="footer-meta">
          © {new Date().getFullYear()} KalakarTechCrew. All rights reserved.
        </div>
      </div>
      <div className="footer-meta">
        Crafted with precision in Indore, India
      </div>
    </footer>
  );
}
